import React, { memo, useEffect } from 'react'
import { usePwaNotificationStore } from '@/components/composed/pwa/Notification/store/usePwaNotificationStore'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { BottomSheet } from './components/BottomSheet/BottomSheet'
import { NotificationModal } from './components/Modal/Modal'
import type { IPwaNotificationProps } from './types'

function PwaNotification(props: IPwaNotificationProps) {
  const { shouldShow, showNativePrompt, isIos, resetPwaState } = props
  const { methods, state } = usePwaNotificationStore()

  const { isTablet, isMobile } = useDeviceType()

  const onDismiss = () => {
    methods.setShown(false)
    methods.setDismissed()
    resetPwaState()
  }

  const onAppInstall = () => {
    onDismiss()
    showNativePrompt()
  }

  useEffect(() => {
    if (shouldShow) return methods.setShown(true)
  }, [methods, shouldShow])

  if (isTablet) return <NotificationModal isIos={isIos} onClose={onDismiss} isOpen={state.isShown} onInstallApp={onAppInstall} />

  if (isMobile) return <BottomSheet isIos={isIos} onClose={onDismiss} isOpen={state.isShown} onInstallApp={onAppInstall} />

  return null
}

export default memo(PwaNotification)
